import {
  SIDEBAR_VISIBLE,
  SIDEBAR_ACTIVE_MENUS,
} from '../../constants/cookieKeys'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Image, Icon } from '@adc/ui-core'
import { getLogoutUrl } from '../../utils/getLogoutUrl'
import { RIGHTS, RESOURCES } from '../../constants/permissions'
import classnames from 'classnames/bind'
import inlineLogo from '../../images/logo/morpheus/inline-light.svg'
import avatar from '../../images/user-avatar.svg'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const NavigationChevron = (
  <div className={cx('u-ml-1', 'u-display-ib')}>
    <Icon name='chevron down' size='small' color='white' />
  </div>
)

class NavigationHeader extends Component {
  static propTypes = {
    cookies: PropTypes.object,
    customLogo: PropTypes.string,
    displayName: PropTypes.string,
    featureFlags: PropTypes.object,
    permissions: PropTypes.object.isRequired,
  }

  static defaultProps = {
    featureFlags: {},
  }

  trigger = (
    <span>
      <Image avatar src={avatar} />
    </span>
  )

  onLogout = () => {
    const { cookies } = this.props
    if (cookies) {
      cookies.remove(SIDEBAR_ACTIVE_MENUS, { path: '/' })
      cookies.remove(SIDEBAR_VISIBLE, { path: '/' })
    }
    document.location.href = getLogoutUrl()
  }

  render() {
    const { customLogo, displayName, featureFlags, permissions } = this.props
    const experimentalHeaderActive = true

    const hasPermissions = resource => {
      return (
        permissions.hasAccess && permissions.hasAccess(resource, RIGHTS.READ)
      )
    }

    const shouldShowFinanceSection =
      featureFlags['fe.resi.is_morpheus_finance_section_enabled'] &&
      hasPermissions(RESOURCES.FINANCE_PAGE)

    const shouldShowLiveAuctionCheckInOutTracker =
      featureFlags['fe.resi.is_live_auction_check_in_out_tracker_enabled'] &&
      hasPermissions(RESOURCES.AUCTIONEER_LIVE_AUCTION_TRACKER_PAGE)

    const shouldShowOrganizationsMenu = hasPermissions(
      RESOURCES.ORGANIZATIONS_PAGE
    )

    const shouldShowCommunicationsMenu =
      featureFlags['fe.resi.is_communications_enabled'] &&
      hasPermissions(RESOURCES.COMMUNICATIONS_PAGE)

    return (
      <div
        className={cx('container', { experimental: experimentalHeaderActive })}
      >
        <div
          className={cx('left-part', {
            experimental: experimentalHeaderActive,
          })}
        >
          <a href='/' data-elm-id='home_link'>
            <Image
              className={cx('icon')}
              src={customLogo || inlineLogo}
              size='small'
            />
          </a>

          <nav className={cx('u-ml-4')}>
            <section className={cx('u-mr-2')}>
              <Dropdown
                trigger='Asset Management'
                floating
                icon={NavigationChevron}
                data-elm-id='asset_management_navigation_tab'
              >
                <Dropdown.Menu>
                  {hasPermissions(RESOURCES.INTAKE_HUB_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Intake Hub'
                      href='/property/intake'
                      data-elm-id='menu_item_intake_hub'
                    />
                  )}
                  {featureFlags['fe.resi.enable-leads-page'] && (
                    <Dropdown.Item
                      as='a'
                      text='Leads'
                      href='/property/leads'
                      data-elm-id='menu_item_leads'
                    />
                  )}
                  {hasPermissions(RESOURCES.PROPERTIES_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Properties'
                      href='/property/properties'
                      data-elm-id='menu_item_properties'
                    />
                  )}
                  {hasPermissions(RESOURCES.LISTINGS_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Listings'
                      href='/property/listings'
                      data-elm-id='menu_item_listings'
                    />
                  )}
                  <Dropdown.Header content='Scheduler' />
                  {hasPermissions(RESOURCES.EVENTS_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Events'
                      href='/schedule/events'
                      data-elm-id='menu_item_events'
                    />
                  )}
                  {hasPermissions(RESOURCES.VENUES_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Venues'
                      href='/schedule/venues'
                      data-elm-id='menu_item_venues'
                    />
                  )}
                  {hasPermissions(RESOURCES.EVENT_TEMPLATES_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Event Templates'
                      href='/schedule/event-templates'
                      data-elm-id='menu_item_event_templates'
                    />
                  )}
                  {hasPermissions(RESOURCES.VENUE_TEMPLATES_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Venue Templates'
                      href='/schedule/venue-templates'
                      data-elm-id='menu_item_venue_templates'
                    />
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </section>
            <section className={cx('u-mr-2')}>
              <Dropdown
                trigger='Marketplace'
                floating
                icon={NavigationChevron}
                data-elm-id='marketplace_navigation_tab'
              >
                <Dropdown.Menu>
                  {hasPermissions(RESOURCES.EMAIL_TEMPLATE_MANAGEMENT_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Email Templates'
                      href='/email-template-management'
                      data-elm-id='menu_item_email_templates'
                    />
                  )}
                  {hasPermissions(RESOURCES.TINY_URL_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Tiny Urls'
                      href='/tiny-url'
                      data-elm-id='menu_item_tiny_urls'
                    />
                  )}
                  {hasPermissions(RESOURCES.DOCUMENTS_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Documents'
                      href='/property/documents'
                      data-elm-id='menu_item_documents'
                    />
                  )}
                  {hasPermissions(RESOURCES.PACKAGES_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Packages'
                      href='/property/packages'
                      data-elm-id='menu_item_packages'
                    />
                  )}
                  {hasPermissions(RESOURCES.LISTING_ATTRIBUTES_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Listing Attributes'
                      href='/property/listing-attributes'
                      data-elm-id='menu_item_listing_attributes'
                    />
                  )}
                  {hasPermissions(RESOURCES.MARKETING_TAGS_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Marketing Tags'
                      href='/property/marketing-tags'
                      data-elm-id='menu_item_marketing_tags'
                    />
                  )}
                  {featureFlags['fe.resi.invitations-management'] &&
                    hasPermissions(RESOURCES.INVITATIONS_PAGE) && (
                      <Dropdown.Item
                        as='a'
                        text='Invitations'
                        href='/invitations'
                        data-elm-id='menu_item_invitations'
                      />
                    )}
                </Dropdown.Menu>
              </Dropdown>
            </section>
            <section className={cx('u-mr-2')}>
              <Dropdown
                trigger='Bidding & Contracting'
                floating
                icon={NavigationChevron}
                data-elm-id='bidding_contracting_navigation_tab'
              >
                <Dropdown.Menu>
                  {hasPermissions(RESOURCES.AUCTIONEER_DASHBOARD_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Auctioneer Dashboard'
                      href='/auctioneer-dashboard'
                      data-elm-id='menu_item_auctioneer_dashboard'
                    />
                  )}
                  {hasPermissions(RESOURCES.TRANSACTION_MANAGER_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Contracting'
                      href='/property/contracting'
                      data-elm-id='menu_item_contracting'
                    />
                  )}
                  {shouldShowLiveAuctionCheckInOutTracker && (
                    <Dropdown.Item
                      as='a'
                      text='Live Auction Check In/Out Tracker'
                      href='/auctioneer-dashboard/live-auction-tracker'
                      data-elm-id='menu_item_live_auction_tracker'
                    />
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </section>
            <section className={cx('u-mr-2')}>
              <Dropdown
                trigger='Closing'
                floating
                icon={NavigationChevron}
                data-elm-id='closing_navigation_tab'
              >
                <Dropdown.Menu>
                  {hasPermissions(RESOURCES.TRANSACTION_MANAGER_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Closing Transactions'
                      href='/property/closings'
                      data-elm-id='menu_item_closings'
                    />
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </section>
            {shouldShowFinanceSection && (
              <section className={cx('u-mr-2')}>
                <Dropdown
                  trigger='Finance'
                  floating
                  icon={NavigationChevron}
                  data-elm-id='finance_navigation_tab'
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      as='a'
                      text='Transaction History'
                      href='/finance/transaction-history'
                      data-elm-id='menu_item_transaction-history'
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </section>
            )}
            <section className={cx('u-mr-2')}>
              <Dropdown
                trigger='Admin'
                floating
                icon={NavigationChevron}
                data-elm-id='admin_navigation_tab'
              >
                <Dropdown.Menu>
                  {hasPermissions(RESOURCES.MORPHEUS_LOGS_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Morpheus Logs'
                      href='/sync/morpheus-logs'
                      data-elm-id='menu_item_morpheus'
                    />
                  )}
                  {hasPermissions(RESOURCES.USERS_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Users'
                      href='/user-management'
                      data-elm-id='menu_item_users'
                    />
                  )}
                  {hasPermissions(RESOURCES.CLIENT_AUTHORIZATION_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='Client Authorization'
                      href='/client-authorization'
                      data-elm-id='menu_item_client_authorization'
                    />
                  )}
                  {shouldShowOrganizationsMenu && (
                    <Dropdown.Item
                      as='a'
                      text='Organizations'
                      href='/organizations'
                      data-elm-id='menu_item_organizations'
                    />
                  )}
                  {shouldShowCommunicationsMenu && (
                    <Dropdown.Item
                      as='a'
                      text='Communications'
                      href='/communications'
                      data-elm-id='menu_item_communications'
                    />
                  )}
                  {hasPermissions(RESOURCES.AI_EVALUATIONS_PAGE) && (
                    <Dropdown.Item
                      as='a'
                      text='AI Evaluations'
                      href='/ai-evaluations'
                      data-elm-id='menu_item_ai_evaluations'
                    />
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </section>
          </nav>
        </div>

        <div className={cx('right-part', 'experimental')}>
          <Dropdown
            trigger={`Hi, ${displayName || 'Stranger'}`}
            floating
            icon={NavigationChevron}
            data-elm-id='menu_user'
          >
            <Dropdown.Menu className={cx('menu-right-aligned')}>
              <Dropdown.Item
                as='a'
                data-elm-id='menu_user_logout'
                text='Logout'
                onClick={this.onLogout}
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    )
  }
}

export default NavigationHeader
